module.exports = __webpack_public_path__ + "img/Blinking_by_Label.131ea181.svg";